(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ea-review-badge"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-ea-review-launch]');
    if (!button || button.dataset.loaded) return;
    button.dataset.loaded = 'true';
    const section = button.closest('.ea-review-badge');
    section.querySelector('[data-ea-review-mount]').append(section.querySelector('template').content.cloneNode(true));
    if (!document.querySelector('script[src="https://elfsightcdn.com/platform.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://elfsightcdn.com/platform.js';
      script.async = true;
      document.head.append(script);
    }
    button.hidden = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ea-sticky-buy"]) return;
  try {
    
  if (!customElements.get('ea-sticky-buy')) {
    customElements.define('ea-sticky-buy', class extends HTMLElement {
      connectedCallback() {
        this.stickyButton = this.querySelector('[data-sticky-add]');
        this.meta = this.querySelector('[data-sticky-meta]');
        this.label = this.querySelector('[data-sticky-label]');
        if (!this.stickyButton || !this.mainButton()) return;
        this.visible = false;
        this.stickyButton.addEventListener('click', () => {
          const main = this.mainButton();
          if (!main) return;
          if (main.disabled) {
            // Uten myk rulling, som i ea-product-setup (Fable-auditen 12.10, A1 #3).
            const html = document.documentElement;
            const before = html.style.scrollBehavior;
            html.style.scrollBehavior = 'auto';
            main.scrollIntoView({ block: 'center' });
            html.style.scrollBehavior = before;
            return;
          }
          main.click();
        });
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.check();
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.onChange = () => {
          clearTimeout(this.changeTimer);
          this.changeTimer = setTimeout(() => this.update(), 400);
        };
        document.addEventListener('change', this.onChange);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            this.update(event && event.data ? event.data.variant : null);
          });
        }
        this.check();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        document.removeEventListener('change', this.onChange);
        clearTimeout(this.changeTimer);
        if (this.unsubscribeVariant) this.unsubscribeVariant();
        document.body.classList.remove('ea-sticky-buy-active');
      }
      mainButton() {
        return document.querySelector('product-info product-form button[name="add"]') || document.querySelector('product-form button[name="add"]');
      }
      check() {
        const main = this.mainButton();
        const show = Boolean(main) && main.getBoundingClientRect().bottom < 0;
        if (show !== this.visible) this.toggle(show);
      }
      toggle(show) {
        this.visible = show;
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', String(!show));
        this.stickyButton.tabIndex = show ? 0 : -1;
        document.body.classList.toggle('ea-sticky-buy-active', show);
        if (show) this.update();
      }
      update(variant) {
        const main = this.mainButton();
        if (!main) return;
        const scope = main.closest('product-info') || document;
        let values = [];
        if (variant && variant.title && variant.title !== 'Default Title') {
          values = Array.isArray(variant.options) ? variant.options.filter(Boolean) : variant.title.split(' / ');
        } else {
          const picked = [...scope.querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select')]
            .map((element) => element.value)
            .filter(Boolean);
          values = [...new Set(picked)];
        }
        const priceBox = scope.querySelector('.price');
        let priceItem = null;
        if (priceBox) {
          priceItem = priceBox.classList.contains('price--on-sale')
            ? priceBox.querySelector('.price__sale .price-item--sale')
            : priceBox.querySelector('.price__regular .price-item--regular');
        }
        const price = priceItem ? priceItem.textContent.trim() : '';
        if (this.label) {
          const model = this.dataset.model || '';
          const parts = values.map((value) => {
            let text = String(value).trim();
            if (model && text.indexOf(model + ' ') === 0) text = text.slice(model.length + 1);
            return text.replace(/^(\d+)\s*stk$/i, '$1 føtter');
          });
          this.label.textContent = parts.length ? [model, ...parts].filter(Boolean).join(' · ') : this.dataset.defaultLabel || model;
        }
        this.meta.textContent = price;
        this.stickyButton.disabled = main.disabled;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('click', async event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target instanceof Element ? event.target.closest('[data-ea-cookie-preferences]') : null;
    if (!link || typeof window.privacyBanner?.showPreferences !== 'function') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    try {
      await window.privacyBanner.showPreferences();
    } catch (_) {
      window.location.assign(link.href);
    }
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
